var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "attachment-name"
  }, [(_vm.attachment.name) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.attachment.name) + "\n  ")]) : _c('span', [(_vm.fallbackName) ? _c('span', [_vm._v(_vm._s(_vm.fallbackName))]) : _c('text-placeholder')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58d40909","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/AttachmentName.vue
// module id = 1998
// module chunks = 0